import * as React from 'react'

import { Container, LoyaltyText, StyledIcon } from './styles'

export interface LoyaltyPointsProps {
  className?: string
  pointsText: string
}

export const LoyaltyPoints = ({
  className,
  pointsText,
}: LoyaltyPointsProps) => {
  return (
    <Container className={className}>
      <StyledIcon />
      <LoyaltyText data-testid="loyalty-points">{pointsText}</LoyaltyText>
    </Container>
  )
}
